import Vue from 'vue';

const resource = '/itemsupplierpricehistories';

export default {
  // CUSTOM ENDPOINT
  getByItemSupplier(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `itemsuppliers/${idPublic}${resource}`
    );
  },
};
